import HttpClient from "./http_client";

import WoosmapStoresApi from "./api/stores";
import WoosmapDistanceApi from "./api/distance";
import WoosmapGeolocationApi from "./api/geoLocation";

import urlsConfig from "../configuration/urls.config";
import {getConfig} from "../configuration/config";

export class WoosmapApiClient {
  private readonly httpClient: HttpClient;
  private readonly _stores: WoosmapStoresApi;
  private readonly _distance: WoosmapDistanceApi;
  private readonly _geoLocation: WoosmapGeolocationApi;

  constructor(params: { apiKey?: string; baseUrl?: string }) {
    this.httpClient = new HttpClient({
      ...params,
      baseUrl: params.baseUrl || urlsConfig.baseApiUrl,
      apiKey: params.apiKey || getConfig().map.woosmapPublicKey,
    });

    this._stores = new WoosmapStoresApi(this.httpClient);
    this._distance = new WoosmapDistanceApi(this.httpClient);
    this._geoLocation = new WoosmapGeolocationApi(this.httpClient);
  }

  public get stores(): WoosmapStoresApi {
    return this._stores;
  }
  public get distance(): WoosmapDistanceApi {
    return this._distance;
  }
  public get geoLocation(): WoosmapGeolocationApi {
    return this._geoLocation;
  }
}
